import React, {Component} from 'react';
import {grey400} from 'material-ui/styles/colors';
import DeleteIconButton from '../../../../components/DeleteIconButton';
import DeleteWidgetMutation from '../../../../mutations/DeleteWidgetMutation';

const styles = {
  wrapper: {
    paddingTop: 34,
    position: 'relative',
    margin: '0 20px',
  },
  divider: {
    backgroundColor: grey400,
    height: 1,
  },
  labelWrapper: {
    marginTop: -10,
  },
  label: {
    backgroundColor: 'white',
    padding: '4px 8px',
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: -18,
    padding: '8px 4px',
  },
}

class PageBreakWidget extends Component {

  deleteWidget = () => {
    DeleteWidgetMutation.commit({
      widgetId: this.props.widget.id,
    });
  };

  render() {
    return (
      <div style={styles.wrapper}>
        <div style={styles.divider}></div>
        <div style={styles.labelWrapper}>
          <span style={styles.label}>Page break</span>
        </div>
        <DeleteIconButton onTouchTap={this.deleteWidget} style={styles.deleteButton} />
      </div>
    );
  }
}

export default PageBreakWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/PageBreakWidget/PageBreakWidget.js